import { computed } from 'vue'
import { selectAccount, selectedAccountID } from '@/composables/globalData/useEntitiesData'
import { ActiveDashboard, selectDashboard } from '@/composables/globalData/useDashoardsData'
import { setupActiveLayout } from '@/composables/globalData/useLayouts'
import GlobalCachedDataService from '@/core/services/cachedData/GlobalCachedDataService'
import debugLog from '@/composables/useDebugLogger'
import useLoadDataCounter from '@/composables/useLoadDataCounter'

const LOADING_DATA_STEP = 0.25

const { updateLoadedDataCount, loadedDataCount } = useLoadDataCounter(LOADING_DATA_STEP)

export const contentLoadingPercentage = computed(() => {
    const localCount = (loadedDataCount.value + GlobalCachedDataService.loadedDataCount.value) / 2
    return Math.round(localCount * 100)
})

async function setupAccount () {
    const getEntitiesListFinish = debugLog('Select account in')
    await selectAccount()
    getEntitiesListFinish()
}

async function setupDashboard () {
    const selectDashboardFinish = debugLog('Select dashboard in')
    await selectDashboard(ActiveDashboard.value)
    selectDashboardFinish()
}

async function setupLayout () {
    const setActiveLayoutFinish = debugLog('Setup active layout in')
    await setupActiveLayout()
    setActiveLayoutFinish()
}

async function setupDashboardData () {
    const appRenderedLogFinish = debugLog('App Rendered in')
    const dataLoadedLogFinish = debugLog('All Dashboard Data Loaded in')
    try {
        /* Load Global Cached Data */
        await GlobalCachedDataService.loadAllData()
        updateLoadedDataCount()
        /* Setup Account */
        await setupAccount()
        await GlobalCachedDataService.loadSelectedAccountEntitiesOnly(selectedAccountID.value)
        updateLoadedDataCount()
        /* Setup Dashboard */
        await setupDashboard()
        /* Setup Active Layout */
        await setupLayout()
        updateLoadedDataCount()
    } catch (e) {
        loadedDataCount.value = 1
    } finally {
        console.log('FINALY')
        dataLoadedLogFinish()
        updateLoadedDataCount()
        appRenderedLogFinish()
    }
}

export default {
    setupDashboardData,
    contentLoadingPercentage
}
